import { useContext } from "react";
import { useSelector } from "react-redux";
import { Group, Identifiable } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeResourceGroup(
    request: Boundaries["removeResourceGroup"]["request"],
  ): void;
}

function useRemoveResourceGroup(group: Identifiable<Group>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isResourceGroupRemovalRequestPending(group),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isResourceGroupRemovalRequestSuccess(group),
    ),
    isRequestFailure: useSelector(() =>
      selector.isResourceGroupRemovalRequestFailure(group),
    ),
    removeResourceGroup: core.removeResourceGroup,
  };
}

export { useRemoveResourceGroup };
